export default "__VITE_PUBLIC_ASSET__e48dc323__"